import { Headers } from '@egw/components'
import { AccountHoldingsDetail } from '@egw/features-holdings'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const InvestmentsAccountHoldingsDetailsPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.investment.title')} />
      <AccountHoldingsDetail />
    </Layout>
  )
}
